var _ellipse, _ellipse2, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgIllustrationMessagerie = function SvgIllustrationMessagerie(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 55",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.167,
    cy: 38.058,
    fill: "var(--secondary-fill)",
    rx: 8.357,
    ry: 8.645,
    transform: "rotate(-90 38.167 38.058)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.733,
    cy: 16.026,
    fill: "var(--secondary-fill)",
    rx: 8.357,
    ry: 8.645,
    transform: "rotate(-90 17.733 16.026)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--secondary-fill)",
    d: "m41.703 18.488.698-5.628 5.822.674-.698 5.628zM7.778 41.562l1.284-5.53 5.72 1.241-1.283 5.53z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M28.466 14.38c-7.58 0-13.746 5.85-13.746 13.042 0 7.191 6.166 13.042 13.746 13.042s13.746-5.85 13.746-13.042S36.046 14.38 28.466 14.38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-white)",
    d: "M25.472 28.582h3.617a.566.566 0 0 0 .585-.58.55.55 0 0 0-.172-.414.6.6 0 0 0-.428-.166h-3.617a.567.567 0 0 0-.585.58q0 .246.172.413a.6.6 0 0 0 .428.167m0-1.74h6.018a.566.566 0 0 0 .586-.581.55.55 0 0 0-.173-.414.6.6 0 0 0-.427-.166h-6.019a.567.567 0 0 0-.585.58q0 .246.172.413a.6.6 0 0 0 .428.167m0-1.742h6.018a.567.567 0 0 0 .586-.58.55.55 0 0 0-.173-.414.6.6 0 0 0-.427-.167h-6.019a.567.567 0 0 0-.585.58q0 .247.172.415a.6.6 0 0 0 .428.166m-3.002 6.718v-9.04q0-.478.353-.82.353-.34.848-.34h9.606q.495 0 .848.34.352.342.352.82v6.965q0 .48-.352.82-.353.34-.848.34h-8.405l-1.381 1.335a.56.56 0 0 1-.653.123.55.55 0 0 1-.368-.543"
  })));
};
export default SvgIllustrationMessagerie;